(() => {
  const SCOPES = [
    {
      name: 'mini',
      checkout: '[data-moq-mini-checkout]',
      subtotal: '[data-moq-mini-subtotal]',
      message: '#moq-message-mini-cart',
      threshold: '[data-moq-mini-checkout]'
    },
    {
      name: 'cart',
      checkout: '[data-moq-cart-checkout]',
      subtotal: '[data-moq-cart-subtotal]',
      message: '#moq-message-cart',
      threshold: '[data-moq-cart-threshold]'
    }
  ];

  let timer = null;

  function parseMoneyToNumber(text) {
    if (!text) return 0;

    const normalized = String(text)
      .replace(/[^\d.,]/g, '')
      .replace(/,/g, '');

    return Number(normalized) || 0;
  }

  function formatGapFromSample(sampleText, amount) {
    const raw = String(sampleText || '');
    const prefix = raw.match(/^[^\d-]+/)?.[0]?.trim() || '';
    const suffix = raw.match(/[A-Z]{3}$/)?.[0] || '';
    const rounded = Math.ceil(Number(amount) || 0);
    const formatted = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (prefix && suffix) return `${prefix}${formatted} ${suffix}`;
    if (prefix) return `${prefix}${formatted}`;
    if (suffix) return `${formatted} ${suffix}`;
    return formatted;
  }

  function getText(el, name, fallback) {
    return el?.getAttribute(name) || fallback;
  }

  function getCurrencyCode(el, name, fallback) {
    return String(el?.getAttribute(name) || fallback || '')
      .trim()
      .toUpperCase();
  }

  function setCheckoutState(buttons, disabled) {
    buttons.forEach((btn) => {
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      btn.classList.toggle('button--disabled', disabled);
      btn.style.opacity = disabled ? '0.55' : '';
      btn.style.pointerEvents = disabled ? 'none' : '';
    });
  }

  function recalcScope(scope) {
    const buttons = Array.from(document.querySelectorAll(scope.checkout));
    const subtotalEl = document.querySelector(scope.subtotal);
    const messageEl = document.querySelector(scope.message);
    const thresholdEl = document.querySelector(scope.threshold);

    if (!buttons.length || !subtotalEl || !messageEl || !thresholdEl) return;

    const subtotalRaw = subtotalEl.textContent || '';
    const thresholdRaw = thresholdEl.getAttribute('data-moq-threshold-presentment') || '';
    const thresholdUsdLabel = thresholdEl.getAttribute('data-moq-threshold-usd') || 'USD 2,000';

    const currentCurrency = getCurrencyCode(
      thresholdEl,
      'data-moq-current-currency',
      'USD'
    );

    const baseCurrency = getCurrencyCode(
      thresholdEl,
      'data-moq-base-currency',
      'USD'
    );

    const shouldShowCurrentCurrencyLine = currentCurrency !== baseCurrency;

    const subtotal = parseMoneyToNumber(subtotalRaw);
    const threshold = parseMoneyToNumber(thresholdRaw);

    if (!subtotal || !threshold) {
      messageEl.innerHTML = '';
      setCheckoutState(buttons, true);
      return;
    }

    if (subtotal >= threshold) {
      messageEl.innerHTML = '';
      setCheckoutState(buttons, false);
      return;
    }

    const gap = threshold - subtotal;

    const textMinimum = getText(
      thresholdEl,
      'data-moq-text-minimum',
      'Minimum order amount is [amount].'
    );

    const textCurrentCurrency = getText(
      thresholdEl,
      'data-moq-text-current-currency',
      '(Approximately [amount] in your current currency)'
    );

    const textRemaining = getText(
      thresholdEl,
      'data-moq-text-remaining',
      'Add [amount] more to checkout.'
    );

    messageEl.innerHTML = `
      <p><strong>${textMinimum.replace('[amount]', thresholdUsdLabel)}</strong></p>
      ${
        shouldShowCurrentCurrencyLine
          ? `<p>${textCurrentCurrency.replace('[amount]', thresholdRaw)}</p>`
          : ''
      }
      <p><strong>${textRemaining.replace('[amount]', formatGapFromSample(thresholdRaw, gap))}</strong></p>
    `;

    setCheckoutState(buttons, true);
  }

  function recalcAll() {
    SCOPES.forEach(recalcScope);
  }

  function schedule(delay = 120) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      recalcAll();
      setTimeout(recalcAll, 120);
      setTimeout(recalcAll, 400);
    }, delay);
  }

  function hookFetch() {
    if (window.__ZP_MOQ_FETCH_HOOKED__) return;
    window.__ZP_MOQ_FETCH_HOOKED__ = true;

    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const res = await originalFetch(...args);

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart.js')
      ) {
        schedule(80);
        schedule(240);
        schedule(520);
      }

      return res;
    };
  }

  function init() {
    hookFetch();
    schedule(80);

    new MutationObserver(() => schedule(160)).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', () => schedule(180));
    document.addEventListener('click', () => schedule(180));

    window.__ZP_MOQ_DEBUG__ = () =>
      SCOPES.map((scope) => ({
        scope: scope.name,
        checkoutFound: !!document.querySelector(scope.checkout),
        subtotalFound: !!document.querySelector(scope.subtotal),
        messageFound: !!document.querySelector(scope.message),
        thresholdFound: !!document.querySelector(scope.threshold),
        subtotalRaw: document.querySelector(scope.subtotal)?.textContent || '',
        thresholdRaw:
          document.querySelector(scope.threshold)?.getAttribute('data-moq-threshold-presentment') || '',
        currentCurrency:
          document.querySelector(scope.threshold)?.getAttribute('data-moq-current-currency') || '',
        baseCurrency:
          document.querySelector(scope.threshold)?.getAttribute('data-moq-base-currency') || 'USD'
      }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();